import { createContext, ReactElement, useMemo, useContext } from 'react';
import useRestaurantData from '../../hooks/useRestaurantData';
import { RestaurantUserEmailInterface } from '../../types/RestaurantInterface';
import { getSubmittedEmails } from '../../api/restaurant';

interface SubmittedEmailsContextInterface {
  hasError: boolean;
  isLoading: boolean;
  emails: RestaurantUserEmailInterface[];
  loadSubmittedEmails: Function;
}

interface SubmittedEmailsProviderInterface {
  children: ReactElement;
}

const SubmittedEmailsContext = createContext<SubmittedEmailsContextInterface>({
  hasError: false,
  isLoading: true,
  emails: null,
  loadSubmittedEmails: () => {}
});

const SubmittedEmailsProvider = ({ children }: SubmittedEmailsProviderInterface) => {
  const {
    data: emails,
    isLoading,
    hasError,
    load: loadSubmittedEmails
  } = useRestaurantData<RestaurantUserEmailInterface[]>(getSubmittedEmails);

  const providerValue = useMemo(
    () => ({
      hasError,
      isLoading,
      emails,
      loadSubmittedEmails
    }),
    [hasError, isLoading, emails, loadSubmittedEmails]
  );
  return <SubmittedEmailsContext.Provider value={providerValue}>{children}</SubmittedEmailsContext.Provider>;
};

const useSubmittedEmailsContext = () => {
  const context = useContext(SubmittedEmailsContext);
  if (!context) {
    throw new Error(`SubmittedEmailsContext must be used within the SubmittedEmailsProvider component`);
  }
  return context;
};

export { SubmittedEmailsProvider as default, useSubmittedEmailsContext };
